import { AdvancedSearchJobsState } from './partials/search-jobs'
import { createSearchResults } from './util'

export const AdvancedSearchState = () => ({
  entities: [],
  entity: null,
  exportable_fields: [],
  exportable_fields_query: [],
  indistinctResults: false,
  interGroupOperator: 'AND',
  isSearching: false,
  loadedJob: null,
  query_groups: [],
  searchJobs: AdvancedSearchJobsState,
  search_results: createSearchResults(),
  searched_query_groups: [],
  selected_results: [],
  show_export_dialog: false,
})
